/** Canvas Global Brand Breath / Opening Splash — visual constants
 * (VISTOERA_CANVAS_SPLASH_AMBIENT_LANGUAGE_AND_VIEWPORT_RESTORE_V3).
 *
 * All language elements exist from frame 0; random phase via negative
 * animation-delay; unified field fade at end only. */

/** Canonical opening splash duration — all timers/animations derive from this. */
export const OPENING_SPLASH_DURATION_MS = 5000

/** @deprecated alias — use OPENING_SPLASH_DURATION_MS */
export const BRAND_BREATH_TOTAL_DURATION_MS = OPENING_SPLASH_DURATION_MS

/** Whole language field fade begins (§VI). */
export const BRAND_BREATH_FINAL_FADE_START_MS = 3700
export const BRAND_BREATH_FINAL_FADE_OUT_MS = OPENING_SPLASH_DURATION_MS - BRAND_BREATH_FINAL_FADE_START_MS

export const BRAND_BREATH_REDUCED_DURATION_MS = 1500

/** Normal translate jitter — ambient spatial drift (§III). */
export const BRAND_BREATH_TRANSLATE_MAX_PX = 10
/** Hard cap — never exceed 12px (§III). */
export const BRAND_BREATH_TRANSLATE_HARD_MAX_PX = 12

/** Spatial layer opacity — visible from first frame (§II). */
export const BRAND_BREATH_FAR_OPACITY: [number, number] = [0.06, 0.14]
export const BRAND_BREATH_MID_OPACITY: [number, number] = [0.12, 0.24]
export const BRAND_BREATH_NEAR_OPACITY: [number, number] = [0.22, 0.32]
export const BRAND_BREATH_ANCHOR_OPACITY: [number, number] = [0.28, 0.38]
export const BRAND_BREATH_KEYWORD_OPACITY: [number, number] = [0.06, 0.12]

/** @deprecated V1 tier aliases — layout uses spatial layers. */
export const BRAND_BREATH_TIER1_OPACITY = BRAND_BREATH_ANCHOR_OPACITY
export const BRAND_BREATH_TIER2_OPACITY = BRAND_BREATH_MID_OPACITY
export const BRAND_BREATH_TIER3_OPACITY = BRAND_BREATH_FAR_OPACITY

export const BRAND_BREATH_TIER1_FONT_PX: [number, number] = [40, 54]
export const BRAND_BREATH_TIER2_FONT_PX: [number, number] = [24, 34]
export const BRAND_BREATH_TIER3_FONT_PX: [number, number] = [14, 24]
export const BRAND_BREATH_KEYWORD_FONT_PX: [number, number] = [72, 120]

/** Long ambient cycles — user sees partial curve within 5s splash (§III). */
export const BRAND_BREATH_CYCLE_MS: [number, number] = [8000, 12000]
export const BRAND_BREATH_KEYWORD_CYCLE_MS: [number, number] = [8000, 12000]

/** @deprecated V2 stagger — V3 uses random phase only. */
export const BRAND_BREATH_FADE_IN_DELAY_MAX_MS = 0
export const BRAND_BREATH_TRANSLATE_FAR_MAX_PX = BRAND_BREATH_TRANSLATE_HARD_MAX_PX
export const BRAND_BREATH_CYCLE_SECONDARY_MS = BRAND_BREATH_CYCLE_MS
export const BRAND_BREATH_DENSITY_REDUCTION_TARGET: [number, number] = [0.35, 0.45]

export const BRAND_BREATH_LAYER_Z_INDEX = 0

export const BRAND_BREATH_CINEMATIC_EASING = 'cubic-bezier(0.37, 0, 0.22, 1)'

/** Scale ranges for motion keyframes (§III–IV). */
export const BRAND_BREATH_SCALE_NORMAL: [number, number] = [0.93, 1.08]
export const BRAND_BREATH_SCALE_FAR: [number, number] = [0.9, 1.1]
export const BRAND_BREATH_SCALE_ANCHOR: [number, number] = [0.99, 1.02]
